import React from 'react'
import styled from 'styled-components'
import { useStoreState } from 'easy-peasy'
import Paragraph from './Paragraph'
import Btn from './BtnLink'
import media from '../../utils/media'
import Image from './Image'
import { useTranslations } from '../../utils/Text'

const Wrapper = styled.div`
  .section-title {
    margin-bottom: 60px;
    ${media.tabletS`
      padding: 0 15px;
      margin-bottom: 30px;
    `}
  }
  .card-wrapper {
    span {
      width: 100%;
    }
    .text-util {
      text-align: center;
      ${media.tabletS`
        padding: 0 30px 20px;
    `}
    }
  }
  .paragraph-check {
    padding: 14px 0 0;
    align-self: center;
  }
`
const ContentWrapper = styled.div`
  padding: 30px 18px;
  max-width: 726px;
  margin: 0 auto;
`
const BtnWrapper = styled.div`
  margin-bottom: 0;
`
const HideMobile = styled.div`
  display: block;
  ${media.mobileL`
    display: none;
  `}
`
const HideDesktop = styled.div`
  display: none;
  ${media.mobileL`
    display: block;
    img {
      width: 100%;
    }
  `}
`

export default function Grid({ config }) {
  const {
    title,
    subtitle,
    contentItem1,
    contentItem2,
    contentItem3,
    contentItem4,
    textAlign,
    titleFontSize,
    titleLineHeight,
    subtitleFontSize,
    subtitleLineHeight,
    marginBText,
    padding,
    paddingMobile,
    imageSrcMobile,
    imageSrc,
    iconSrc,
    alt,
    width,
    fontFamily,
    btn,
  } = config
  const imgToShow = useTranslations(imageSrc, {})
  const imgToShowMobile = useTranslations(imageSrcMobile, {})
  const iconToShow = useTranslations(iconSrc, {})
  const locale = useStoreState(state => state.locale.locale)
  const [validated] = useStoreState(state => [state.form.validated])

  const LOCALE = {
    es: locale === 'es-es',
    longContent:
      locale === 'es-es' ||
      locale === 'es-cl' ||
      locale === 'es-ar' ||
      locale === 'es-pe' ||
      locale === 'es-co' ||
      locale === 'es-mx' ||
      locale === 'pt-br' ||
      locale === 'pt-pt' ||
      locale === 'it-it' ||
      locale === 'de-de' ||
      locale === 'nl-be' ||
      locale === 'en-gb' ||
      locale === 'fr-fr',

    mediumContent: locale === 'en-us',

    latam:
      locale === 'es-cl' ||
      locale === 'es-ar' ||
      locale === 'es-pe' ||
      locale === 'es-co' ||
      locale === 'es-mx',

    europe:
      locale === 'pt-br' ||
      locale === 'pt-pt' ||
      locale === 'it-it' ||
      locale === 'de-de' ||
      locale === 'nl-be' ||
      locale === 'fr-fr' ||
      locale === 'en-gb',
  }

  // console.log(contentItem1)

  return (
    <Wrapper>
      {imageSrc && !imageSrcMobile && (
        <Image className={HideMobile} src={imgToShow} alt={alt} />
      )}
      {imageSrcMobile && (
        <>
          <HideMobile>
            <Image className={HideMobile} src={imgToShow} alt={alt} />
          </HideMobile>
          <HideDesktop>
            <Image src={imgToShowMobile} alt={alt} />
          </HideDesktop>
        </>
      )}
      <ContentWrapper>
        {title && (
          <Paragraph
            paragraph={title}
            marginB={marginBText}
            padding={padding}
            paddingMobile={paddingMobile}
            fontSize={titleFontSize}
            lineHeight={titleLineHeight}
          />
        )}

        <div className="row">
          {subtitle && (
            <Paragraph
              classN="col-12 col-md-10 mx-auto"
              paragraph={subtitle}
              marginB={marginBText}
              fontSize={subtitleFontSize}
              lineHeight={subtitleLineHeight}
              fontFamily={fontFamily}
            />
          )}
          <div className="col-11 col-md-10 mx-md-auto">
            <div className="d-flex">
              <Image src={iconToShow} alt={alt} width={width} />
              <Paragraph
                classN="paragraph-check"
                paragraph={contentItem1}
                textAlign={textAlign}
                marginB={marginBText}
                fontSize={subtitleFontSize}
                lineHeight={subtitleLineHeight}
                fontFamily={fontFamily}
              />
            </div>
            <div className="d-flex">
              <Image src={iconToShow} alt={alt} width={width} />
              <Paragraph
                classN="paragraph-check"
                paragraph={contentItem2}
                textAlign={textAlign}
                marginB={marginBText}
                fontSize={subtitleFontSize}
                lineHeight={subtitleLineHeight}
                fontFamily={fontFamily}
              />
            </div>
            {(LOCALE.mediumContent || LOCALE.longContent) && (
              <div className="d-flex">
                <Image src={iconToShow} alt={alt} width={width} />
                <Paragraph
                  classN="paragraph-check"
                  paragraph={contentItem3}
                  textAlign={textAlign}
                  marginB={marginBText}
                  fontSize={subtitleFontSize}
                  lineHeight={subtitleLineHeight}
                  fontFamily={fontFamily}
                />
              </div>
            )}
            {LOCALE.longContent && (
              <div className="d-flex">
                <Image src={iconToShow} alt={alt} width={width} />
                <Paragraph
                  classN="paragraph-check"
                  paragraph={contentItem4}
                  textAlign={textAlign}
                  marginB={marginBText}
                  fontSize={subtitleFontSize}
                  lineHeight={subtitleLineHeight}
                  fontFamily={fontFamily}
                />
              </div>
            )}
          </div>
        </div>
      </ContentWrapper>
      {validated === null && btn && !LOCALE.latam && !LOCALE.europe && (
        <BtnWrapper>
          <Btn
            href={btn.hrefBtn}
            btnText={btn.btnText}
            btnBg={btn.btnBg}
            btnColor={btn.btnColor}
            btnWidth={btn.btnWidth}
          />
        </BtnWrapper>
      )}
    </Wrapper>
  )
}
